// key は graffer-schemas で定義されている input type
// value は kintone で定義されている field type
// repeatable <> SUBTABLE の対応関係は、設定データ上は表現しない。
// （それぞれの子要素同士の対応関係から逆算する）
export const KintoneExportFieldCorrespondences = {
  text: ["SINGLE_LINE_TEXT"],
  date: ["DATE"],
  date_range: [],
  time: ["TIME"],
  time_range: [],
  datetime: [],
  datetime_range: [],
  year_month: [],
  text_area: ["MULTI_LINE_TEXT"],
  number: ["NUMBER"],
  checkboxes: ["CHECK_BOX", "MULTI_SELECT"],
  radio_buttons: ["RADIO_BUTTON"],
  email: ["SINGLE_LINE_TEXT"],
  tel: ["SINGLE_LINE_TEXT"],
  select: ["DROP_DOWN"],
  file: ["FILE"],
  my_number: [],
  formula_result: ["NUMBER"],
  postal_code: ["SINGLE_LINE_TEXT"],
} as const;
